import type { Breakpoint, BreakpointsOptions } from '@mui/material';

// https://material-ui.com/customization/breakpoints/

const values: { [key in Breakpoint]: number } = {
  xs: 0,
  sm: 1024,
  md: 1280,
  lg: 1440,
  xl: 1920,
};

const breakpoints: BreakpointsOptions = {
  keys: ['xs', 'sm', 'md', 'lg', 'xl'] as Breakpoint[],
  values,
};

export default breakpoints;
